enum NotificationType {
    MbiVerification,
    ApplicationSuccess,
    ApplicationSuccessMbiVerificationRequired,
    MbiSuccessfullyUpdated,
    PendingApplicationReviewReminder,
    PendingApplicationDeclined,
    AhipCertificationOpen,
    CertificationOrTrainingOverdue,
    ExpiringLicenses,
    EnrollmentStatusUpdate,
}

export default NotificationType;
